import React from 'react';

import { TeamsIcon } from '@atlaskit/logo';
import { AppLogo } from '@atlaskit/navigation-system/top-nav-items';
import { useIntl } from 'react-intl';

import { AnalyticsTopNavItem, useSendTopNavItemClick } from '@townsquare/analytics-nav4';
import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { generatePath } from '@townsquare/router/primitives/path';
import { teamsAppForYouRoute } from '@townsquare/routes/teams-app-for-you-view';

export function ProductHome(): React.JSX.Element {
	const sendTopNavItemClick = useSendTopNavItemClick();
	const routeDependencies = useRouteDependencies();
	const intl = useIntl();

	return (
		<AppLogo
			icon={TeamsIcon}
			name="Teams"
			label={intl.formatMessage({
				id: 'townsquare.teams-app.top-nav.logo-label',
				description:
					'Accessible label for the teams app logo link in the top left of the navigation which takes users to the home page',
				defaultMessage: 'Teams app home page',
			})}
			href={generatePath(teamsAppForYouRoute, routeDependencies)}
			onClick={() => {
				sendTopNavItemClick(AnalyticsTopNavItem.PRODUCT_LOGO);
			}}
		/>
	);
}
